import { render, staticRenderFns } from "./index.vue?vue&type=template&id=57ece8d7&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=57ece8d7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ece8d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ece8d7')) {
      api.createRecord('57ece8d7', component.options)
    } else {
      api.reload('57ece8d7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=57ece8d7&scoped=true&", function () {
      api.rerender('57ece8d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/type/index.vue"
export default component.exports